import React, { useState, useEffect } from "react";
import "./HomeContent.css";
// import AboutCardData from "../data/AboutCardData.json";
import AboutReadiContent from "./AboutReadiContent";
import FrameworksTabs from "./FrameworksTabs";
import RolebasedData from "../data/RolebasedData";
import { Link } from "react-router-dom";
import Testimonials from "./Testimonials";
import AOS from "aos";
import "aos/dist/aos.css";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { submitUserRoles} from "../Redux/UserMaintanence";
import { HomeImagesParams} from "../imagesData/ImagesData";
import axios from "axios";
import baseUrl from "../utils/Constants.js";

function HomeContent({bannerimg}) {

  const [imageUrls, setImageUrls] = useState({});
  const query = `params=${encodeURIComponent(JSON.stringify(HomeImagesParams))}`;

  useEffect(() => {
    const fetchImageUrls = async () => {
      try {
        const response = await axios.get(`${baseUrl}/images?${query}`)
        setImageUrls(response.data); 
      } catch (error) {
        console.error('Error fetching image URLs:', error);
      }
    };
  
    fetchImageUrls();
    AOS.init({ duration: 800 });
  }, []);

  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const dispatch = useDispatch()
  let username = ""
  if(activeAccount)
   username = activeAccount.idTokenClaims.enterpriseID;
  const userData = useSelector((state) => state.userRoles.UserMaintanenceData)
  // const [username, setUsername] = React.useState();
  const [currentUserRoles, setCurrentuserRoles] =useState(userData.filter((item) => item.Enterprise_ID === username))

  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  useEffect(() => {
    setCurrentuserRoles(
      userData?.filter((item) => item.Enterprise_ID === username)
    );
  }, [userData]);

  return (
    <>
      <div className="main-banner">
        <img
          src={bannerimg}
          alt="banner"
          className="banner-img"
        />
      </div>
      {/* second section */}
      <AboutReadiContent />
      {/* <div className="about-cards-sec">
        <div className="about-cards-wrap">
          {AboutCardData.map((post) => {
            return (
              <div
                key={post.id}
                className="about-cards-row"
                data-aos="zoom-in-up"
              >
                <div className="about-cards-box">
                  <img
                    src="images/Home/Card-shadow.png"
                    alt="shadow"
                    className="Card-shadow"
                  />
                  <div className="icon-heading-wrap">
                    <div className="icon-heading-row row1">
                      <img
                        src={post.icon}
                        alt="icons"
                        className="heading-icon"
                      />
                    </div>
                    <div className="icon-heading-row row2">
                      <h3>{post.heading}</h3>
                    </div>
                  </div>
                  <img
                    src="images/Home/gradient-underline-new.png"
                    alt="underline"
                    className="gradient-underline"
                  />
                  <ul className="about-bullets">
                    <li>{post.bullets1}</li>
                    <li>{post.bullets2}</li>
                  </ul>
                </div>
              </div>
            );
          })}
        </div>
      </div> */}
      {/* first section */}
      {/* <div className="about-readi-sec">
        <div className="about-readi-wrap" data-aos="zoom-in-up">
          <h2>About Vodafone Talent Academy</h2>
          <div className="about-readi-row row1">
            <div className="about-readi-box">
              <p>
                Introducing Vodafone Talent Academy: our exclusive learning
                portal designed as a comprehensive program to create a
                future-skilled workforce for the Vodafone Talent Academy
                account.
              </p>
              <p>
                This sophisticated platform is meticulously designed for
                targeted projects, aimed at career building and upskilling in
                emerging technologies. Amidst a cacophony of information,
                Vodafone Talent Academy serves as a refined haven for those
                seeking an in-depth exploration of specific domains.
              </p>
              <p>
                Welcome to a realm where dedicated commitment meets bespoke
                education, propelling learners towards a future defined by
                specialized proficiency and achievement.
              </p>
              <p className="domains-path">
                <a href="/VodafoneTalentAcademy/home#Roles">Go to Roles...</a>
              </p>
            </div>
          </div>
          <div className="about-readi-row row2">
            <div className="about-readi-box">
              <iframe
                id="kmsembed-1_rftnn4lf"
                width="100%"
                height="280"
                // src="https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_rftnn4lf/uiConfId/27188232/st/0"
                src=""
                class="kmsembed"
                allowfullscreen
                webkitallowfullscreen
                mozAllowFullScreen
                allow="autoplay *; fullscreen *; encrypted-media *"
                referrerPolicy="no-referrer-when-downgrade"
                frameborder="0"
                title="Welcome the Vodafone Program"
              ></iframe>
            </div>
          </div>
        </div>
      </div> */}

      <div className="about-readi-sec-new">
        <div className="about-readi-wrap-new" data-aos="zoom-in-up">
          <h2>About VodafoneThree Talent Academy</h2>
          <div className="about-readi-row row1-new">
            <div className="about-readi-box-new">
              <p>
                {/* Introducing Vodafone Talent Academy: our exclusive learning
                portal designed as a comprehensive program to create a
                future-skilled workforce for the Vodafone Talent Academy
                account. */}
                This exclusive learning portal designed as a comprehensive
                program to create a future-skilled workforce having multiple
                skills.
              </p>
              <p>
                {/* This sophisticated platform is meticulously designed for
                targeted projects, aimed at career building and upskilling in
                emerging technologies. Amidst a cacophony of information,
                Vodafone Talent Academy serves as a refined haven for those
                seeking an in-depth exploration of specific domains. */}
                This sophisticated platform is meticulously designed for
                targeted projects, aimed at career building and upskilling in
                emerging technologies. This platform has unique features to
                build a custom learning plan for any individual. This would help
                build a tailored learning experience which is quick and
                effective.
              </p>
              {/* <p>
                Welcome to a realm where dedicated commitment meets bespoke
                education, propelling learners towards a future defined by
                specialized proficiency and achievement.
              </p> */}
              <p className="domains-path">
                <a href="/VodafoneTalentAcademy/home#Roles">Go to Roles...</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* third section */}
      <div className="framework-tabs-sec" id="VodafoneTalentAcademy">
        <div className="framework-tabs-wrap">
          <h2>VodafoneThree Talent Academy</h2>
          <FrameworksTabs imagesObj={imageUrls?.imageUrl}/>
        </div>
      </div>
      {/* fourth section */}
      <div className="role-based-sec" id="Roles">
        <div className="role-text-box">
          <h2>Roles</h2>
          <p>
            {/* Embark on a journey of professional growth with our comprehensive
            learning programs, tailored to cultivate expertise in diverse roles
            such as System Engineering, Backend Development, Web Development,
            Solution Architecture, and Automation Engineering. Whether you
            aspire to design robust IT infrastructures, craft visually stunning
            web experiences, architect strategic solutions, or streamline
            processes through automation, our courses provide hands-on knowledge
            and practical skills to propel your career in the dynamic landscape
            of technology. */}
            Explore professional growth through our tailored learning programs
            in System Engineering, Backend, Web and Full Stack Development, and
            Automation Engineering. Gain hands-on knowledge and skills to
            advance your career in technology, whether you aim to design IT
            infrastructures, create web experiences, architect solutions, or
            streamline processes.
          </p>
        </div>
        <div className="role-based-wrap">
          {RolebasedData.map((post) => {
            return (
              currentUserRoles?.[0]?.[post.coursename] === "yes" && (
              <div
                key={post.id}
                className="role-based-row"
                data-aos="zoom-in-up"
              >
                <div className="role-based-box">
                  <div className="role-based-img-box">
                    <a href={post.courselink}>
                      <img
                        src={process.env.PUBLIC_URL + post.courseimg}
                        alt="course"
                        className="course-tile-img"
                      />
                    </a>
                  </div>
                  <div className="domains-extra-box">
                    <h3>{post.coursehead}</h3>
                    <p className="domains-para">{post.coursetext}</p>
                    <p className="learning-link">
                      <a href={post.courselink}>Go to Learning</a>
                    </p>
                  </div>
                </div>
              </div>
            ));
          })}
        </div>
      </div>
      {/* fifth section */}
      <div className="testimonial-sec" id="Testimonials">
        <div className="testimonial-wrap">
          <h2>Testimonials</h2>
          <Testimonials imagesObj={imageUrls?.imageUrl}/>
        </div>
      </div>
    </>
  );
}

export default HomeContent;
